import { WifiOff } from '@tamagui/lucide-icons';
import { useTranslation } from 'react-i18next';
import { YStack, Stack, Text } from 'tamagui';
import { tokens } from 'tamagui-config';

export const NoInternetConnectionView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <YStack alignItems="center">
      <Stack
        width={288}
        height={288}
        borderRadius={9999}
        borderWidth={1}
        borderColor="rgba(255, 255, 255, 0.05)"
        backgroundImage="linear-gradient(-135deg, rgba(188, 209, 224, 0.05), rgba(0, 0, 0, 0.05))"
        alignItems="center"
        justifyContent="center">
        <WifiOff size={133} color={tokens.color.warningRed} />
      </Stack>

      <Text fontFamily="$heading" fontSize="$8" fontWeight="$4" color="$color12" textAlign="left">
        {t('lock.noInternet')}
      </Text>
    </YStack>
  );
};
